import { Instance } from 'mobx-state-tree';
import { OrderUnscheduledFromDeletedRouteDtoModelBase } from './OrderUnscheduledFromDeletedRouteDtoModel.base';

/* The TypeScript type of an instance of OrderUnscheduledFromDeletedRouteDtoModel */
export interface OrderUnscheduledFromDeletedRouteDtoModelType extends Instance<typeof OrderUnscheduledFromDeletedRouteDtoModel.Type> {}

/* A graphql query fragment builders for OrderUnscheduledFromDeletedRouteDtoModel */
export { selectFromOrderUnscheduledFromDeletedRouteDto, orderUnscheduledFromDeletedRouteDtoModelPrimitives, OrderUnscheduledFromDeletedRouteDtoModelSelector } from './OrderUnscheduledFromDeletedRouteDtoModel.base';

/**
 * OrderUnscheduledFromDeletedRouteDtoModel
 */
export const OrderUnscheduledFromDeletedRouteDtoModel = OrderUnscheduledFromDeletedRouteDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
